'use client';

import React from 'react';
import { ROUTES } from '@/constants/routes/default';
import Link from 'next/link';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import { signOut, useSession } from 'next-auth/react';
import { cn } from '@/helpers/common';
import HeaderDropdownKG from './HeaderDropdownKG';

const desktopLinkCn =
  'text-sm font-medium px-4 py-2 text-kg-black-pearl no-underline default-transition hover:text-kg-fun-blue';

function HeaderKG() {
  const pathname = usePathname();
  const { data: value } = useSession();
  const session = value;

  return (
    <header className="flex md:px-10 max-md:px-4 min-h-20 border-b border-kg-athens-gray bg-white">
      <div className="max-w-295 w-full h-full flex justify-between items-center m-auto flex-wrap gap-4">
        <Link href={ROUTES.home} aria-label="Kimble Group home">
          <Image
            width="144"
            height="12"
            src="https://assets.kimblegroup.com/kimblegroup/2024-04/logo_v2.png"
            alt="Kimble Group"
            unoptimized
            priority
          />
        </Link>
        <nav aria-label="Main" className="md:flex max-md:hidden items-center gap-2">
          <a
            aria-current={pathname === ROUTES.jobs ? 'page' : undefined}
            className={cn(desktopLinkCn, { underline: pathname === ROUTES.jobs })}
            href={ROUTES.jobs}
          >
            SEARCH ALL JOBS
          </a>
          <a
            aria-current={pathname === ROUTES.partners ? 'page' : undefined}
            className={cn(desktopLinkCn, { underline: pathname === ROUTES.partners })}
            href={ROUTES.partners}
          >
            PARTNERSHIPS
          </a>
          {session && (
            <a
              aria-current={pathname === ROUTES.profile ? 'page' : undefined}
              className={cn(desktopLinkCn, {
                underline: pathname === ROUTES.profile || pathname === ROUTES.history,
              })}
              href={ROUTES.profile}
            >
              CAREER PROFILE
            </a>
          )}
        </nav>
        <div className="md:flex max-md:hidden items-center gap-2">
          {session ? (
            <button className={desktopLinkCn} onClick={() => signOut()}>
              SIGN OUT
            </button>
          ) : (
            <>
              <a className={cn(desktopLinkCn)} href={ROUTES.signin}>
                LOG IN
              </a>
              <a
                className={
                  'text-sm text-white font-medium px-4 py-2 rounded-sm bg-kg-fun-blue hover:bg-kg-deep-sapphire default-transition'
                }
                href={ROUTES.signup}
              >
                REGISTER
              </a>
            </>
          )}
        </div>
        <div className="md:hidden max-md:block">
          <HeaderDropdownKG session={session} isSighInPath={pathname === ROUTES.signin} />
        </div>
      </div>
    </header>
  );
}

export default HeaderKG;
